import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// Kadro talebinin ücret aralığı kademe bandının dışındaysa (gönderimde sunucu hesaplar — spec 2026-10-27 §7.3)
// onaycıya gösterilen rozet. Yeni onay adımı yok; karar İK İş Ortağının onayında. Stil: HireFlagBadge deseni.
const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  background: ${({ $above }) => ($above ? '#FDECEA' : '#E7F1FF')};
  color: ${({ $above }) => ($above ? '#C62828' : '#0B5FA5')};
`;

export default function BandDeviationBadge({ deviation }) {
  const { t } = useTranslation();
  if (deviation !== 'above_band' && deviation !== 'below_band') return null;
  return (
    <Badge $above={deviation === 'above_band'} data-testid={`band-deviation-${deviation}`}>
      {t(`ats.requisition.bandDeviation.${deviation}`)}
    </Badge>
  );
}
